import {
    Box,
    Button,
    CloseButton,
    Container,
    Dialog,
    Field,
    Image,
    Input,
    SimpleGrid,
    Stack,
    Text,
} from "@chakra-ui/react";
import { React, useContext, useState } from "react";
import { NumericFormat } from "react-number-format";

import ButtonIcon from "@/components/Requerimiento/ButtonIcon";
import ButtonText from "@/components/Requerimiento/ButtonText";
import { context } from "@/context/requirementsContext";
import { usePostRequirementMutation } from "@/hooks/microservicesApi";

const ListHeader = ({ children }) => {
    return (
        <Text fontWeight="700" fontSize="xl" mb={2}>
            {children}
        </Text>
    );
};

const CaracteristicasTerreno = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isSuccessOpen, setIsSuccessOpen] = useState(false);

    const onSuccessOpen = () => setIsSuccessOpen(true);
    const onSuccessClose = () => setIsSuccessOpen(false);

    const [useLand, setUseLand] = useState("Habitacional");
    const [terrainForm, setTerrainForm] = useState("Regular");
    const [topography, setTopography] = useState("Plano");

    const [desdeSuperficie, setDesde_superficie] = useState(0);
    const [hastaSuperficie, setHasta_superficie] = useState(0);
    const [frenteSuperficie, setFrente_superficie] = useState(0);
    const [fondoSuperficie, setFondo_superficie] = useState(0);
    const [desdeConstruccion, setDesde_construccion] = useState(0);
    const [hastaConstruccion, setHasta_construccion] = useState(0);

    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [postRequirement] = usePostRequirementMutation();

    const {
        addDataTerrain,
        addDataUser,
        updateStep,
        dataGeneral,
        dataProperty,
        dataTerrain,
        // location,
    } = useContext(context);

    const terrain = ["Regular", "Irregular"];
    const topograph = ["Plano", "Desnivel"];

    const uso_suelo = [
        {
            value: "Habitacional",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/casa.webp",
        },
        {
            value: "Comercial",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/comercial.webp",
        },
        {
            value: "Turismo",
            icon: "https://media.grupoguia.mx/assets/home-page/requerimiento/turismo.webp",
        },
    ];

    const handleSubmit = (e) => {
        let data = [
            {
                name: "forma_terreno",
                value: terrainForm,
            },
            {
                name: "topografia",
                value: topography,
            },
            {
                name: "uso_de_suelo",
                value: useLand,
            },
            {
                name: "superficie_min_terreno",
                value: desdeSuperficie ? desdeSuperficie : 0,
            },
            {
                name: "superficie_max_terreno",
                value: hastaSuperficie ? hastaSuperficie : 0,
            },
            {
                name: "superficie_frente_terreno",
                value: frenteSuperficie ? frenteSuperficie : 0,
            },
            {
                name: "superficie_fondo_terreno",
                value: fondoSuperficie ? fondoSuperficie : 0,
            },
            {
                name: "superficie_min_construccion",
                value: desdeConstruccion ? desdeConstruccion : 0,
            },
            {
                name: "superficie_max_construccion",
                value: hastaConstruccion ? hastaConstruccion : 0,
            },
        ];

        addDataTerrain(data);

        setIsFormOpen(true);

        updateStep(2);
    };

    const handleSubmitUser = (e) => {
        let data = [
            {
                name: "firstname",
                value: name + " " + lastname,
            },
            {
                name: "email",
                value: email,
            },
            {
                name: "phone",
                value: phone,
            },
        ];

        addDataUser(data);

        sendData(data);
    };

    const sendData = (dataUser) => {
        let data_aux = {
            fields: [...dataUser, ...dataTerrain, ...dataGeneral, ...dataProperty],
            context: {
                ipAddress: "3.14.97.137",
                pageUri: "www.grupoguia.mx",
                pageName: "Grupo Guia | Requerimiento",
            },
        };

        postRequirement(JSON.stringify(data_aux))
            .then((response) => {
                setIsFormOpen(false);
                onSuccessOpen();
            })
            .catch((error) => {
                console.error("Error: ", error);
                setIsFormOpen(false);
            });
    };

    const setValueButton = (type, value) => {
        switch (type) {
            case "useLand": {
                setUseLand(value);
                break;
            }
            case "terrainForm": {
                setTerrainForm(value);
                break;
            }
            case "topography": {
                setTopography(value);
                break;
            }
        }
    };

    const numericFormatStyle = {
        margin: "15px 0px",
        padding: "0.5rem 1.5rem",
        border: "1px solid #e4e4e7",
        borderRadius: "55px",
        outline: "none",
        marginTop: "20px",
    };

    return (
        <>
            <Box
                bg="blackAlpha.50"
                color="black.600"
                _dark={{ bg: "whiteAlpha.100", color: "gray.200" }}
                w="full"
                mx="auto"
                maxW="3x1"
                px={{ base: "2", md: "8" }}
                py={6}
                my={4}
            >
                <Container
                    maxW="6xl"
                    p={0}
                    py={10}
                    pt={0}
                    _dark={{ borderColor: "gray.700" }}
                    asChild
                >
                    <Stack>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit(e);
                            }}
                        >
                            <SimpleGrid
                                columns={{ base: 1, sm: 1, md: 2 }}
                                gap={{ md: 8, base: 4 }}
                            >
                                <Stack align="flex-start">
                                    <ListHeader>Uso de suelo:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 3 }}
                                        gap={{ md: 8, base: 4 }}
                                    >
                                        {uso_suelo.map((use) => {
                                            return (
                                                <ButtonIcon
                                                    key={`uso-de-suelo_button-${use.value}`}
                                                    variant={
                                                        useLand === use.value ? "solid" : "outline"
                                                    }
                                                    onclick={(e) => {
                                                        setValueButton("useLand", use.value);
                                                    }}
                                                    icon={use.icon}
                                                    active={useLand === use.value}
                                                >
                                                    {use.value}
                                                </ButtonIcon>
                                            );
                                        })}
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start"></Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Forma de terreno:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 2 }}
                                        gap={{ md: 8, base: 2 }}
                                    >
                                        {terrain.map((t, i) => (
                                            <ButtonText
                                                key={`forma_terreno_button_${i}`}
                                                variant={terrainForm === t ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("terrainForm", t);
                                                }}
                                                active={terrainForm === t}
                                            >
                                                Terreno {t}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>

                                <Stack align="flex-start">
                                    <ListHeader>Topografía:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 2 }}
                                        gap={{ md: 8, base: 2 }}
                                    >
                                        {topograph.map((t, i) => (
                                            <ButtonText
                                                key={`topografia_button_${i}`}
                                                variant={topography === t ? "solid" : "outline"}
                                                onclick={() => {
                                                    setValueButton("topography", t);
                                                }}
                                                active={topography === t}
                                            >
                                                Terreno {t}
                                            </ButtonText>
                                        ))}
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Superficie de terreno:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 2 }}
                                        gap={{ md: 8, base: 2 }}
                                        mt={10}
                                    >
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="desde_superficie"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Desde m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="desde_superficie"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setDesde_superficie(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="hasta_superficie"
                                                mb="0"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Hasta m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="hasta_superficie"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setHasta_superficie(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                    </SimpleGrid>
                                </Stack>

                                <Stack align="flex-start">
                                    <Stack minH={9} align="flex-start" />
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 2 }}
                                        gap={{ md: 8, base: 2 }}
                                        mt={10}
                                    >
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="frente_superficie"
                                                mb="0"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Frente m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="frente_superficie"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setFrente_superficie(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="fondo_superficie"
                                                mb="0"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Fondo m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="fondo_superficie"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setFondo_superficie(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                    </SimpleGrid>
                                </Stack>
                                <Stack align="flex-start">
                                    <ListHeader>Superficie de construcción:</ListHeader>
                                    <SimpleGrid
                                        columns={{ base: 2, sm: 2, md: 2 }}
                                        gap={{ md: 8, base: 2 }}
                                        mt={10}
                                    >
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="desde_superficie_construccion"
                                                mb="0"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Desde m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="desde_superficie_construccion"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setDesde_construccion(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                        <Field.Root border="1px" borderColor="gray.200">
                                            <Field.Label
                                                htmlFor="hasta_superficie_construccion"
                                                mb="0"
                                                fontSize="sm"
                                                ml={4}
                                            >
                                                Hasta m²:
                                            </Field.Label>
                                            <NumericFormat
                                                id="hasta_superficie_construccion"
                                                allowNegative={false}
                                                style={numericFormatStyle}
                                                thousandSeparator={true}
                                                onInput={(e) => {
                                                    setHasta_construccion(
                                                        e.target.value
                                                            .replaceAll("$", "")
                                                            .replaceAll(",", "")
                                                            .replaceAll(/[A-Za-z]+/g, "")
                                                    );
                                                }}
                                            />
                                        </Field.Root>
                                    </SimpleGrid>
                                </Stack>
                            </SimpleGrid>

                            <SimpleGrid
                                columns={{ base: 1, sm: 1, md: 2 }}
                                gap={{ md: 8, base: 4 }}
                                pt={10}
                            >
                                <Stack align="center">
                                    <Button
                                        rounded="full"
                                        colorPalette="brand"
                                        bg="brand.500"
                                        color="black"
                                        border="0"
                                        px="16"
                                        my="4"
                                        _hover={{ bg: "brand.600" }}
                                        onClick={() => {
                                            updateStep(1);
                                        }}
                                    >
                                        Atrás
                                    </Button>
                                </Stack>
                                <Stack align="center">
                                    <Button
                                        rounded="full"
                                        colorPalette="brand"
                                        bg="brand.500"
                                        color="black"
                                        border="0"
                                        px="16"
                                        my="4"
                                        _hover={{ bg: "brand.600" }}
                                        type="submit"
                                    >
                                        Siguiente
                                    </Button>
                                </Stack>
                            </SimpleGrid>
                        </form>
                    </Stack>
                </Container>
                <Dialog.Root
                    placement="center"
                    open={isFormOpen}
                    onOpenChange={() => {
                        setIsFormOpen(false);
                    }}
                >
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Dialog.Content bg="#f8f8f8" p={6} color="gray.600">
                            <Dialog.Header align="center" pt={9}>
                                <Text fontWeight={700}>Ingresa tus datos:</Text>
                            </Dialog.Header>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton />
                            </Dialog.CloseTrigger>
                            <Dialog.Body>
                                <Stack direction="row">
                                    <Container alignSelf="center">
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSubmitUser(e);
                                            }}
                                        >
                                            <Field.Root direction="column" mt={4} required>
                                                <Input
                                                    id="nombre"
                                                    type="text"
                                                    rounded="full"
                                                    placeholder="Nombre(s)*"
                                                    bg="white"
                                                    px={4}
                                                    required
                                                    onInput={(e) => setName(e.target.value)}
                                                />
                                            </Field.Root>
                                            <Field.Root direction="column" mt={4} required>
                                                <Input
                                                    id="apellidos"
                                                    type="text"
                                                    rounded="full"
                                                    placeholder="Apellidos*"
                                                    bg="white"
                                                    px={4}
                                                    required
                                                    onInput={(e) => setLastname(e.target.value)}
                                                />
                                            </Field.Root>
                                            <Field.Root direction="column" mt={4} required>
                                                <Input
                                                    id="telefono"
                                                    type="number"
                                                    rounded="full"
                                                    placeholder="Teléfono*"
                                                    bg="white"
                                                    px={4}
                                                    required
                                                    maxlength={10}
                                                    onInput={(e) => setPhone(e.target.value)}
                                                />
                                            </Field.Root>
                                            <Field.Root direction="column" mt={4} mb={4} required>
                                                <Input
                                                    id="email"
                                                    type="email"
                                                    rounded="full"
                                                    placeholder="Email*"
                                                    bg="white"
                                                    px={4}
                                                    required
                                                    onInput={(e) => setEmail(e.target.value)}
                                                />
                                            </Field.Root>
                                            <Stack align="center">
                                                <Button
                                                    rounded="full"
                                                    colorPalette="brand"
                                                    bg="brand.500"
                                                    color="white"
                                                    border="0"
                                                    px="16"
                                                    my="4"
                                                    fontWeight={300}
                                                    _hover={{ bg: "brand.600" }}
                                                    type="submit"
                                                >
                                                    Enviar
                                                </Button>
                                            </Stack>
                                        </form>
                                    </Container>
                                </Stack>
                            </Dialog.Body>
                            <Dialog.Footer />
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>
                <Dialog.Root open={isSuccessOpen} onOpenChange={onSuccessClose} placement="center">
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Dialog.Content overflow="visible">
                            <Dialog.Header />
                            <Dialog.CloseTrigger asChild zIndex={1000}>
                                <CloseButton />
                            </Dialog.CloseTrigger>
                            <Dialog.Body>
                                <Stack direction="row" my={6} px={6}>
                                    <Image
                                        boxSize="100px"
                                        objectFit="cover"
                                        src="https://media.grupoguia.mx/assets/home-page/requerimiento/marca-verificacion.webp"
                                        alt="Verificacion"
                                        loading="lazy"
                                    />
                                    <Container alignSelf="center">
                                        <Text fontWeight="600" fontSize="2xl" mb={2}>
                                            ¡GENIAL!
                                        </Text>
                                        <Text fontWeight="300" fontSize="sm" mb={2}>
                                            La solicitud se ha enviado correctamente.
                                        </Text>
                                    </Container>
                                </Stack>
                            </Dialog.Body>
                            <Dialog.Footer />
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>
            </Box>
        </>
    );
};

export default CaracteristicasTerreno;
